import AddIcon from '@mui/icons-material/Add';
import { Bert } from 'meteor/themeteorchef:bert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import {
  FormControl,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Stack
} from '@mui/material';
import Modal from '@mui/material/Modal';
import PropTypes from 'prop-types';
import React from 'react';
import SaveIcon from '@mui/icons-material/Save';

import uuid from 'uuid/v1';

import handleErrorInClient from '../../../modules/handle-error-in-client';
import methodPromise from '../../../modules/method-promise-wrapper';
import useTimeStore from '../ZustandProvider';
import { useStyles } from '../../../styles/mapStylesCustom';

const getModalStyle = () => {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`
  };
};

const Editor = props => {
  const { idMap, map } = props;

  const classes = useStyles();
  const casos = useTimeStore(state => state.casos);
  const data = useTimeStore(state => state.data);
  const setData = useTimeStore(state => state.setData);
  const elemento = useTimeStore(state => state.elemento);
  const setElemento = useTimeStore(state => state.setElemento);
  const save = useTimeStore(state => state.save);
  const setSave = useTimeStore(state => state.setSave);

  const cleanvalue = {
    id: uuid(),
    name: 'Nombre',
    width: 4,
    height: '100px',
    componente: 'Nada',
    color: 'elco',
    arriba: 12,
    arribasize: '0px',
    izquierda: 4
  };

  const [values, setValues] = React.useState(cleanvalue);
  const [modalStyle] = React.useState(getModalStyle);
  const [modal, setModal] = React.useState(false);

  const handleChange = (prop, value) => {
    setValues({ ...values, [prop]: value });
  };

  const Buscador = nodes => {
    if (nodes.id === elemento) {
      if (nodes.id === 'h3H9rvh0Ok') {
        setValues({
          ...values,
          id: nodes.id,
          name: nodes.name,
          width: nodes.width,
          color: nodes.color,
          height: nodes.height,
          componente: nodes.componente,
          arriba: nodes.arriba,
          arribasize: nodes.arribasize,
          izquierda: nodes.izquierda
        });
      } else {
        setValues({ ...values, ...nodes });
      }
    } else if (Array.isArray(nodes.child)) {
      nodes.child.map(node => Buscador(node));
    }
  };

  React.useEffect(() => {
    Buscador(props.data);
  }, [elemento]);

  React.useEffect(() => {
    if (elemento === 0) {
      setElemento(data.id);
    }
  }, [data]);

  const editordeNodos = nodes => {
    if (nodes.id === values.id) {
      Object.assign(nodes, values);
    } else if (Array.isArray(nodes.child)) {
      nodes.child.map(node => editordeNodos(node));
    }
  };

  const saveNode = async () => {
    const newdata = data;
    editordeNodos(newdata);
    setData(newdata);
    try {
      await methodPromise('maps.updateMapVar', idMap, newdata);
      setSave(!save);
      Bert.alert('Saved!', 'success');
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  const saveTemplate = async () => {
    const B = map.templates;
    const A = {
      id: uuid(),
      type: 'plantilla',
      name: `Template${B.child.length}`,
      template: data
    };
    B.child.push(A);
    try {
      await methodPromise('maps.updateMapTemplate', idMap, B);
      Bert.alert('Saved!', 'success');
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  const addNode = () => {
    data.child.push(cleanvalue);
    setSave(!save);
  };

  const removeNode = async () => {
    const newdata = data;
    const newchild = data.child;
    const index = data.child.map(object => object.id).indexOf(elemento);
    delete newchild.splice(index, 1);
    newdata.child = newchild;
    try {
      await methodPromise('maps.updateMapVar', idMap, newdata);
      setSave(!save);
    } catch (error) {
      handleErrorInClient(error);
    }
    setModal(false);
  };

  const body = (
    <div style={modalStyle} className={classes.modalPaper}>
      <h3>¿Deseas eliminar el componente {values.name}?</h3>
      <Button color="primary" onClick={() => removeNode()}>
        Si
      </Button>
      <Button color="error" onClick={() => setModal(false)}>
        Cancelar
      </Button>
    </div>
  );

  return (
    <>
      <p />
      <Box
        component="form"
        noValidate
        autoComplete="off"
        padding="1"
        margin="6px"
        sx={{
          '& > :not(style)': { m: 1 },
          display: 'grid',
          gridTemplateColumns: { sm: '1fr 1fr', md: '1fr 1fr', xl: '1fr 1fr' },
          gap: 2
        }}
      >
        <FormControl variant="outlined">
          <InputLabel htmlFor="component-outlined">Name</InputLabel>
          <OutlinedInput
            value={values.name}
            onChange={event => handleChange('name', event.target.value)}
            label="Name"
            startAdornment={<InputAdornment position="start">Name</InputAdornment>}
          />
        </FormControl>
        <FormControl variant="outlined">
          <InputLabel htmlFor="component-outlined">Color</InputLabel>
          <OutlinedInput
            value={values.color}
            onChange={event => handleChange('color', event.target.value)}
            label="Color"
            startAdornment={<InputAdornment position="start">Style</InputAdornment>}
          />
        </FormControl>
        <FormControl variant="outlined">
          <InputLabel htmlFor="component-outlined">Width</InputLabel>
          <OutlinedInput
            type="number"
            value={values.width}
            onChange={event => handleChange('width', parseInt(event.target.value, 10))}
            label="width"
            inputProps={{
              min: 1,
              max: 12
            }}
            startAdornment={<InputAdornment position="start">Colum</InputAdornment>}
          />
        </FormControl>
        <FormControl variant="outlined">
          <InputLabel htmlFor="component-outlined">Height</InputLabel>
          <OutlinedInput
            value={values.height}
            onChange={event => handleChange('height', event.target.value)}
            label="Height"
            startAdornment={<InputAdornment position="start">vh</InputAdornment>}
          />
        </FormControl>
        <FormControl>
          <InputLabel htmlFor="component-outlined">Arriba</InputLabel>
          <OutlinedInput
            type="number"
            value={values.arriba}
            disabled={values.name === 'Raíz'}
            onChange={event => handleChange('arriba', parseInt(event.target.value, 10))}
            label="Arriba"
            inputProps={{
              min: 1,
              max: 12
            }}
            startAdornment={<InputAdornment position="start">Colum</InputAdornment>}
          />
        </FormControl>
        <FormControl>
          <InputLabel htmlFor="component-outlined">ArribaSize</InputLabel>
          <OutlinedInput
            value={values.arribasize}
            disabled={values.name === 'Raíz'}
            onChange={event => handleChange('arribasize', event.target.value)}
            label="Arriba Size"
            startAdornment={<InputAdornment position="start">vh</InputAdornment>}
          />
        </FormControl>
        <FormControl>
          <InputLabel htmlFor="component-outlined">Izquierda</InputLabel>
          <OutlinedInput
            type="number"
            value={values.izquierda}
            disabled={values.name === 'Raíz'}
            onChange={event => handleChange('izquierda', parseInt(event.target.value, 10))}
            label="Izquierda"
            inputProps={{
              min: 1,
              max: 12
            }}
            startAdornment={<InputAdornment position="start">Colum</InputAdornment>}
          />
        </FormControl>
        <FormControl sx={{ gridColumn: '1 / 3' }}>
          <InputLabel htmlFor="component-outlined">Componente</InputLabel>
          <Select
            value={values.componente}
            onChange={event => {
              handleChange('componente', event.target.value);
            }}
            label="Componente"
          >
            {casos.map(item => (
              <MenuItem key={item} value={item}>
                {item}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
      <Stack
        padding={1}
        spacing={1}
        direction="row"
        alignItems="center"
        justifyContent="space-around"
      >
        <Button
          variant="outlined"
          color="success"
          size="small"
          onClick={addNode}
          startIcon={<AddIcon />}
        >
          Add
        </Button>
        <Button
          variant="outlined"
          className={classes.azulIpsilumButton}
          size="small"
          onClick={saveNode}
          startIcon={<SaveIcon />}
        >
          Save
        </Button>
        <Button
          type="button"
          variant="outlined"
          color="error"
          size="small"
          onClick={() => setModal(true)}
          startIcon={<DeleteIcon />}
        >
          Delete
        </Button>
        <Button
          variant="outlined"
          color="success"
          size="small"
          onClick={saveTemplate}
          startIcon={<AddIcon />}
        >
          Template
        </Button>
        <Modal open={modal} onClose={() => setModal(false)}>
          {body}
        </Modal>
      </Stack>
    </>
  );
};
Editor.defaultProps = {
  map: {},
  data: {}
};
Editor.propTypes = {
  map: PropTypes.object,
  data: PropTypes.object,
  idMap: PropTypes.string.isRequired
};
export default Editor;
